import { NewsContent } from '@/types/blocks';

export const BLOCKS_FALLBACK_TITLE = 'Новость';

const normalize = (value: string) => value.replace(/\s+/g, ' ').trim();
const clamp = (value: string, max: number) => (max > 0 && value.length > max ? value.slice(0, max) : value);

export const extractBlocksMeta = (content?: NewsContent | null, titleMax = 100, teaserMax = 250) => {
  const blocks = Array.isArray(content?.blocks) ? [...content!.blocks] : [];
  const ordered = blocks.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const headingBlock = ordered.find((b) => b.type === 'heading' && typeof (b as any).content === 'string' && (b as any).content.trim());
  const titleFromHeading = normalize(((headingBlock as any)?.content as string) || '');

  const pickTeaserText = (block: any) => {
    switch (block?.type) {
      case 'text':
      case 'quote':
        return block?.content;
      // Комментарий на русском: для описания берём только первый "текстовый" блок, чтобы потом можно было его скрыть из тела.
      default:
        return '';
    }
  };
  const teaserBlock = ordered.find((b) => {
    const text = pickTeaserText(b as any);
    return typeof text === 'string' && text.trim();
  });
  const teaserFromFirstText = normalize(pickTeaserText(teaserBlock as any) || '');

  const teaser = teaserFromFirstText;
  const title = titleFromHeading || teaser;
  return {
    title: clamp(title, titleMax),
    teaser: clamp(teaser, teaserMax),
    titleBlockId: titleFromHeading ? (headingBlock as any)?.id : undefined,
    teaserBlockId: teaserFromFirstText ? (teaserBlock as any)?.id : undefined,
  };
};

export const getNewsDisplayMeta = (news?: {
  title?: string | null;
  teaser?: string | null;
  content_blocks?: NewsContent | null;
}) => {
  const rawTitle = String(news?.title || '').trim();
  const rawTeaser = String(news?.teaser || '').trim();
  const blocksMeta = extractBlocksMeta(news?.content_blocks);

  const hasBlocks = Boolean((news as any)?.content_blocks?.blocks?.length);
  // Комментарий на русском: если есть блоки — считаем, что новость в режиме "Блоки" и превалируют блоки.
  const title = rawTitle || (hasBlocks ? blocksMeta.title : '') || BLOCKS_FALLBACK_TITLE;
  const teaser = rawTeaser || (hasBlocks ? blocksMeta.teaser : '');

  return { title, teaser };
};
